<template>
  <svg
    enable-background="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="70" y="308" width="52" height="132" rx="14" />
    <rect x="162" y="248" width="52" height="192" rx="14" />
    <rect x="254" y="188" width="52" height="252" rx="14" />
    <path
      fill-rule="evenodd"
      d="M368 66 a86 86 0 1 0 0 172 a86 86 0 1 0 0 -172 z M368 94 a58 58 0 1 1 0 116 a58 58 0 1 1 0 -116 z"
    />
    <path
      d="M426 194 l56 56 a14 14 0 0 1 -20 20 l-56 -56 a14 14 0 0 1 20 -20 z"
    />
  </svg>
</template>
